import LandingPage from './LandingPage/LandingPage';
import SRELandingPage from './SRELandingPage/SRELandingPage';
import Accounts from './Accounts/Accounts';
import Policies from './Policies/Policies';
import Activities from './Activities/Activities';
import Analytics from './Analytics/Analytics';
import AccountDetails from './Accounts/AccountDetails/AccountDetails';
import PolicyDetails from './Policies/PolicyDetails/PolicyDetails';
import NewQuoteAccountSearch from './NewQuote/NewQuoteAccountSearch';
import NewQuotePage from './NewQuote/NewQuote/NewQuotePage';
import SearchResults from './SearchResults/SearchResults';
import MLSearchResults from './Components/MLSearchResults/MLSearchResults';
import MLARSSearchResults from './Components/MLARSSearchResults/MLARSSearchResults';
import QuoteDetails from './QuoteDetails/QuoteDetails';
import Renewal from './Renewal/Renewal';
import Endorsement from './Endorsement/Endorsement';
import Cancellation from './Cancellation/Cancellation';
import AccountBillingAndPayment from './Accounts/BillingAndPayment/BillingAndPayment';
import MakePayment from './Accounts/BillingAndPayment/MakePayment/MakePayment';
import ContactUnderwriter from './ContactUnderwriter/ContactUnderwriter';
import PaymentConfirmation from './Accounts/BillingAndPayment/PaymentConfirmation/PaymentConfirmation';
import ContactRoles from './Components/ContactRoles/ContactRoles';
import gatewayMessages from './gateway.messages';
import accountMessages from './Accounts/Accounts.messages';
import CommonRoutes from './Common/CommonRouting';
import MLContactUs from './MLContactUs/MLContactUs';

import MLPELandingPage from './MLPELandingPage/MLPELandingPage';
import ActivityReportsPage from './ActivityReports/ActivityReportsPage';
import MLViewAllPoliciesPage from './Policies/ViewAllPolicies/MLViewAllPoliciesPage';
import ActivityReportsComponent from './Components/ActivityReportsComponent/ActivityReportsComponent';
import MLJobResultsFilterComponent from './Components/MLJobResultsFilterComponent/MLJobResultsFilterComponent';
import MLPolicyChangesReportComponent from './Components/MLPolicyChangesReportComponent/MLPolicyChangesReportComponent';
import MLRenewalsReportComponent from './Components/MLRenewalsReportComponent/MLRenewalsReportComponent';
import MLClaimsReportComponent from './Components/MLClaimsReportComponent/MLClaimsReportComponent';
import MLDelinquentsReportComponent from './Components/MLDelinquentsReportComponent/MLDelinquentsReportComponent';
import MLFollowUpsReportComponent from './Components/MLFollowUpsReportComponent/MLFollowUpsReportComponent';
import MLProducerNewsComponent from './Components/MLProducerNewsComponent/MLProducerNewsComponent';
import MLCancellationsReportComponent from './Components/MLCancellationsReportcomponent/MLCancellationsReportComponent';
import MLIncompletePendedReportComponent from './Components/MLIncompletePendedReportComponent/MLIncompletePendedReportComponent';
import MLContingenciesReportComponent from './Components/MLContingenciesReportComponent/MLContingenciesReportComponent';
import MLPaymentLogComponent from './Components/MLPaymentLogComponent/MLPaymentLogComponent';
import MLMigrationsReportComponent from './Components/MLMigrationsReportComponent/MLMigrationsReportComponent';
import MLMoratoriumsComponent from './Components/MLMoratoriumsComponent/MLMoratoriumsComponent';
import MLQuotesReportComponent from './Components/MLQuotesReportComponent/MLQuotesReportComponent';
import ActivitiesAndNotesComponent from './Components/ActivitiesAndNotesComponent/ActivitiesAndNotesComponent';
import MLHistoryNotesComponent from './Components/MLHistoryNotesComponent/MLHistoryNotesComponent';
import MLActivitiesComponent from './Components/MLActvitiesComponent/MLActivitiesComponent';

const producerEngageComponentMap = {
    ContactRoles: { component: 'ContactRoles' },
    ActivityReportsComponent: { component: 'ActivityReportsComponent' },
    MLJobResultsFilterComponent: { component: 'MLJobResultsFilterComponent' },
    MLPolicyChangesReportComponent: { component: 'MLPolicyChangesReportComponent' },
    MLRenewalsReportComponent: { component: 'MLRenewalsReportComponent' },
    MLClaimsReportComponent: { component: 'MLClaimsReportComponent' },
    MLDelinquentsReportComponent: { component: 'MLDelinquentsReportComponent' },
    MLFollowUpsReportComponent: { component: 'MLFollowUpsReportComponent' },
    MLProducerNewsComponent: { component: 'MLProducerNewsComponent' },
    MLCancellationsReportComponent: { component: 'MLCancellationsReportComponent' },
    MLIncompletePendedReportComponent: { component: 'MLIncompletePendedReportComponent' },
    MLContingenciesReportComponent: { component: 'MLContingenciesReportComponent' },
    MLPaymentLogComponent: { component: 'MLPaymentLogComponent' },
    MLMigrationsReportComponent: { component: 'MLMigrationsReportComponent' },
    MLMoratoriumsComponent: { component: 'MLMoratoriumsComponent' },
    MLQuotesReportComponent: { component: 'MLQuotesReportComponent' },
    ActivitiesAndNotesComponent: { component: 'ActivitiesAndNotesComponent' },
    MLActivitiesComponent: {component: 'MLActivitiesComponent'},
    MLHistoryNotesComponent: {component: 'MLHistoryNotesComponent'}

};

const producerEngageAdditionalComponents = {
    ContactRoles,
    ActivityReportsComponent,
    MLJobResultsFilterComponent,
    MLPolicyChangesReportComponent,
    MLRenewalsReportComponent,
    MLClaimsReportComponent,
    MLDelinquentsReportComponent,
    MLFollowUpsReportComponent,
    MLProducerNewsComponent,
    MLCancellationsReportComponent,
    MLIncompletePendedReportComponent,
    MLContingenciesReportComponent,
    MLPaymentLogComponent,
    MLMigrationsReportComponent,
    MLMoratoriumsComponent,
    MLQuotesReportComponent,
    ActivitiesAndNotesComponent,
    MLActivitiesComponent,
    MLHistoryNotesComponent
};

export { default as summaryMessages } from './Endorsement/Summary/Summary.messages';

export {
    LandingPage as default,
    SRELandingPage,
    Accounts,
    Policies,
    Activities,
    Analytics,
    AccountDetails,
    PolicyDetails,
    NewQuoteAccountSearch,
    NewQuotePage,
    SearchResults,
    MLSearchResults,
    MLARSSearchResults,
    QuoteDetails,
    Renewal,
    Endorsement,
    Cancellation,
    AccountBillingAndPayment,
    MakePayment,
    ContactUnderwriter,
    PaymentConfirmation,
    ContactRoles,
    MLViewAllPoliciesPage,
    producerEngageComponentMap,
    producerEngageAdditionalComponents,
    gatewayMessages,
    accountMessages,
    CommonRoutes,
    ActivityReportsPage,
    MLPELandingPage,
    MLContactUs
};

export { default as AutomaticPaymentPolicyAffectedValueIterableComponent } from './Accounts/BillingAndPayment/AutomaticPaymentPolicyAffectedValueIterableComponent';
export { default as PageHeaderComponent } from './Components/PageHeader/PageHeaderComponent';
export { default as MLPartnerCarrierPopupMsg } from './Components/MLPartnerCarrierPopup/MLPartnerCarrierPopup.messages';
export { default as MLPartnerCarrierPopup } from './Components/MLPartnerCarrierPopup/MLPartnerCarrierPopup';